import img1 from './assets/1.webp';
import img2 from './assets/2.webp';
import img3 from './assets/3.webp';
import img4 from './assets/4.webp';

export const comfortContent = {
  title: [
    { text: 'технологии\n комфорта: ', accent: true },
    { text: ' дом, который ', accent: false },
    { text: 'заботится о вас', accent: false },
  ],
  subtitle: [
    { text: 'инженерия в «Причале» работает незаметно,', accent: true },
    { text: ' создавая идеальный микроклимат и безопасность', accent: false },
  ],
  cards: [
    {
      image: img1,
      title: [
        { text: 'лучевая разводка', accent: true },
        { text: 'и климат-контроль', accent: false },
      ],
      text: [
        {
          text: 'все коммуникации отопления спрятаны в&nbsp;стяжке пола. это дает эстетический вид комнатам и&nbsp;эффект теплого пола в&nbsp;зоне прохождения труб.',
          accent: true,
        },
        {
          text: 'стальные радиаторы оснащены терморегуляторами: вы сами настраиваете погоду в доме, не отапливая улицу',
          accent: false,
        },
      ],
    },
    {
      image: img2,
      title: [
        { text: 'вход в квартиру', accent: true },
        { text: 'без ключей', accent: false },
      ],
      text: [
        {
          text: 'на входных дверях всех квартир установлены электронные замки с&nbsp;биометрией.',
          accent: true,
        },
        {
          text: 'вам больше не нужна связка ключей: дверь открывается по отпечатку пальца, код-паролю или брелоку. это удобно для детей (не потеряют ключ) и безопасно для вас.',
          accent: false,
        },
      ],
    },
    {
      image: img3,
      title: [
        { text: 'умный дренаж', accent: true },
        { text: 'для кондиционеров', accent: false },
      ],
      text: [
        {
          text: 'для каждого кондиционера предусмотрен отвод конденсата напрямую в ливневую канализацию.',
          accent: true,
        },
        {
          text: 'никакого звука капающей воды по подоконникам и луж на тротуаре — фасад дома всегда остается сухим и опрятным',
          accent: false,
        },
      ],
    },
    {
      image: img4,
      title: [
        { text: 'система', accent: true },
        { text: 'очистки воды', accent: false },
      ],
      text: [
        {
          text: 'в доме установлена система доочистки воды с индивидуальным выводом на&nbsp;кухонную зону в&nbsp;каждой квартире.',
          accent: true,
        },
        {
          text: 'вода проходит дополнительную фильтрацию, избавляясь от жестких примесей, прежде чем попасть к вам на кухню',
          accent: false,
        },
      ],
    },
  ],
};
